// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"tm_a bik_a bik_r bik_j","Photos__img":"tm_b bik_b"};